<template>
  <div class="ele-body formInput">
    <el-form
      ref="checkForm"
      :model="checkForm"
      :rules="rules"
      label-width="110px"
      style="
        max-width: 700px;
        margin: 10px auto;
        overflow-y: scroll;
        overflow-x: scroll;
      "
    >
      <el-form-item label="姓名:" prop="interviewee">
        <el-input v-model="checkForm.interviewee" placeholder="请输入姓名" clearable />
      </el-form-item>
      <el-form-item label="日期:" prop="inputDate">
        <el-date-picker v-model="checkForm.inputDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" />
      </el-form-item>
      <el-form-item label="违纪原因一级:" prop="egiId">
        <el-select v-model="egiId" placeholder="请选择违纪原因" class="ele-fluid" clearable @change="getReasonListSec">
          <el-option v-for="(item, index) in reasonListFirst" :key="index" :label="item.egiName" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="违纪原因二级:" prop="egiId">
        <el-select v-model="checkForm.egiId" placeholder="请选择违纪原因" class="ele-fluid" clearable>
          <el-option v-for="(item, index) in reasonListSec" :key="index" :label="item.egiName" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="分值:" prop="scoreId">
        <el-select v-model="checkForm.scoreId" placeholder="请选择分值" class="ele-fluid" clearable>
          <el-option v-for="(item, index) in scoreList" :key="index" :label="item.score" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="照片:" prop="photo">
        <el-upload
          class="avatar-uploader"
          :action="$http.defaults.baseURL + '/file/getFilePath'"
          :headers="$http.defaults.headers.common"
          :data="{ path: 'checkListImg/' }"
          name="multipartFile"
          :show-file-list="false"
          :on-success="uploadSuccess"
          :before-upload="beforeAvatarUpload"
          accept="image/png,image/jpg,image/jpeg"
        >
          <img v-if="checkForm.photo" :src="checkForm.photo" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="督察员签字:" prop="signatory">
        <el-input v-model="checkForm.signatory" placeholder="请输入督察员" clearable />
      </el-form-item>
      <el-form-item label="备注:" prop="remark">
        <el-input type="textarea" v-model="checkForm.remark" placeholder="请输入备注" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit" :loading="loading">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { saveInformBill, getItemScoreList, getItemListFirst, getItemLists } from '@/config/api';

  export default {
    name: 'Input',
    data() {
      return {
        loading: false, // 加载状态
        classId: '',
        checkForm: {
          photo: '',
        },
        rules: {
          // 表单验证规则
          interviewee: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
          inputDate: [{ required: true, message: '请选择起止日期', trigger: 'change' }],
          egiId: [{ required: true, message: '请选择违纪原因', trigger: 'change' }],
          scoreId: [{ required: true, message: '请选择分则', trigger: 'change' }],
          signatory: [{ required: true, message: '请输入督察员', trigger: 'blur' }],
          remark: [{ required: true, message: '请输入备注', trigger: 'blur' }],
        },
        scoreList: [],
        reasonListFirst: [],
        reasonListSec: [],
        egiId: '',
      };
    },
    mounted() {
      // 获取违纪原因列表
      this.getReasonListFirst();
      // 获取分值列表
      this.getSocreList();
    },
    methods: {
      // 获取违纪原因列表
      getReasonListFirst() {
        getItemListFirst().then((res) => {
          if (res.data.resCode == 200) {
            this.reasonListFirst = res.data.data;
          }
        });
      },
      // 获取分值列表
      getSocreList() {
        getItemScoreList().then((res) => {
          if (res.data.resCode == 200) {
            this.scoreList = res.data.data;
          }
        });
      },
      getReasonListSec(item) {
        getItemLists({ id: item }).then((res) => {
          if (res.data.resCode == 200) {
            this.reasonListSec = res.data.data;
          }
        });
      },
      //照片上传限制
      beforeAvatarUpload(file) {
        const extension = file.name.substring(file.name.lastIndexOf('.') + 1) === 'png';
        const extension2 = file.name.substring(file.name.lastIndexOf('.') + 1) === 'jpg';
        if (!extension && !extension2) {
          this.$message.error('只能上传png、jpg格式的图片');
          return false;
        }
      },
      // 上传单个照片成功
      uploadSuccess(res) {
        if (res.resCode == 200) {
          this.checkForm.photo = res.data[0].fileUrl;
        }
      },
      submit() {
        this.$refs['checkForm'].validate((valid) => {
          if (valid) {
            this.loading = true;
            let formData = new FormData();
            for (let key in this.checkForm) {
              if (this.checkForm[key] !== null && this.checkForm[key] !== undefined) {
                formData.append(key, this.checkForm[key]);
              }
            }
            formData.append('classId', this.classId);
            saveInformBill(formData).then((res) => {
              this.loading = false;
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs['checkForm'].resetFields();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>

<style scoped>
  .formInput {
    /*margin-top: 30px;*/
    overflow-x: scroll;
    overflow-y: scroll;
    height: calc(100vh - 150px);
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #cccccc;
  }
  .avatar-uploader-icon:hover {
    border: 1px dashed #3aa1ff;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
</style>
